import React, { createContext, useReducer } from 'react'

export const SET_CAPITAL_HARNESS_PLUGIN_DATA = 'SET_CAPITAL_HARNESS_PLUGIN_DATA'
export const SET_SELECTED_IDS = 'SET_SELECTED_IDS'
export const SHOW_CAPITAL_HARNESS_UPLOAD_POPUP = 'SHOW_CAPITAL_HARNESS_UPLOAD_POPUP'
export const SHOW_CAPITAL_HARNESS_CLONE_POPUP = 'SHOW_CAPITAL_HARNESS_CLONE_POPUP'
export const SET_UPLOAD_FILE_STATUS = 'SET_UPLOAD_FILE_STATUS'
export const SET_GENERATE_FILE_STATUS = 'SET_GENERATE_FILE_STATUS'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_CAPITAL_HARNESS_PLUGIN_DATA: {
      return { ...data, data: payload.data }
    }
    case SET_SELECTED_IDS: {
      let tempSelectedIds = [...data.selectedIds]
      let item = payload.data
      tempSelectedIds.indexOf(item) === -1
        ? tempSelectedIds.push(item)
        : tempSelectedIds.splice(tempSelectedIds.indexOf(item), 1)
      return { ...data, selectedIds: tempSelectedIds }
    }
    case SHOW_CAPITAL_HARNESS_UPLOAD_POPUP: {
      return { ...data, show_upload_popup: payload.data }
    }
    case SHOW_CAPITAL_HARNESS_CLONE_POPUP: {
      return {
        ...data,
        show_clone_popup: payload.showClonePopup,
        selected_object: payload.data || {},
        selected_type: payload.selectedType || {},
      }
    }
    case SET_UPLOAD_FILE_STATUS: {
      return {
        ...data,
        in_process_upload_files: payload.data,
      }
    }
    case SET_GENERATE_FILE_STATUS: {
      return {
        ...data,
        in_process_generate_file_ids: payload.data || [],
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  data: [],
  selectedIds: [],
  show_upload_popup: false,
  show_clone_popup: false,
  selected_object: {},
  selected_type: {},
  in_process_upload_files: false,
  in_process_generate_file_ids: [],
}

const CapitalHarnessStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <CapitalHarnessContext.Provider value={[state, dispatch]}>
      {children}
    </CapitalHarnessContext.Provider>
  )
}

export const CapitalHarnessContext = createContext(initialState)
export default CapitalHarnessStore
